export default __webpack_public_path__ + "4cf922ee47c801d97169449a3ac2e77e.svg";